import { GlobalToken, theme } from "antd";
import { CSSProperties, PropsWithChildren, ReactNode } from "react";
import { useScrollTop } from "src/hooks/useScrollTop";
import { CssVars } from "src/components/CssVars";

export const EntityScreen: React.FC<PropsWithChildren> = ({ children }) => {
  const { token } = theme.useToken();
  const [scrollRef, scrollTop] = useScrollTop();
  return (
    <CssVars>
      <div style={layoutStyle(token)}>
        <div style={mainStyle(token)}>{children}</div>
        {/* <div style={siderStyle(token)}>{props.insightsPanel}</div> */}
      </div>
    </CssVars>
  );
};

const layoutStyle: DynamicCss = (_) => ({
  width: "100%",
  height: "100%",
  display: "flex",
  gap: 0,
});

const mainStyle: DynamicCss = (_) => ({
  height: "100%",
  overflow: "auto",
  minWidth: 0,
  maxWidth: "100%",
  flex: 1,
  display: "flex",
  flexDirection: "column",
  gap: 16,
  position: "relative",
});

type DynamicCss = (token: GlobalToken) => CSSProperties;
